var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaterSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.972 28.4356C31.972 31.992 29.1738 34.875 25.722 34.875C22.2702 34.875 19.472 31.992 19.472 28.4356C19.472 22.8011 25.722 16.125 25.722 16.125C25.722 16.125 31.972 22.8011 31.972 28.4356Z",
    fill: "#10100F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0341 15.1877C30.339 9.49255 21.1053 9.49255 15.4101 15.1877L13.937 13.7146C20.4457 7.20582 30.9984 7.20582 37.5072 13.7146C40.7479 16.9553 42.3753 21.2008 42.3887 25.447V25.4503V29.2346L45.8189 25.8045L47.292 27.2776L42.0837 32.4859L41.3471 33.2225L40.6105 32.4859L35.4022 27.2776L36.8753 25.8045L40.3053 29.2345V25.4535V25.4519C40.2932 21.734 38.8697 18.0233 36.0341 15.1877ZM15.4101 35.8117C21.1053 41.5068 30.339 41.5068 36.0341 35.8117L37.5072 37.2848C30.9984 43.7935 20.4457 43.7935 13.937 37.2848C10.6837 34.0314 9.05629 29.7657 9.05543 25.503V21.7642L5.62534 25.1943L4.15219 23.7211L9.36053 18.5128L10.0971 17.7762L10.8337 18.5128L16.042 23.7211L14.5689 25.1943L11.1388 21.7642V25.5026C11.1396 29.2354 12.5631 32.9647 15.4101 35.8117Z",
    fill: "#10100F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterSvg);
export default __webpack_public_path__ + "static/media/waterSvg.60ba11d85fdf8ac93b486deac95b2ab2.svg";
export { ForwardRef as ReactComponent };